import { gql } from '@apollo/client';

export const validateApplicablePromocode = gql`
  query validateApplicablePromocodePPC($id: String, $promoCodes: [PromoCode], $transactionAccountId: String) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      promoCodesApplicable(promoCodes: $promoCodes) {
        promotionId
        redeemedCount
        promotions {
          id
          title
          maxRedemptions
          promotionCodeType
          benefits {
            benefitType
            duration
            subBenefitType
            iterations
            value
            values {
              appliedOn
              value
            }
            scale
            type
            customisable {
              value {
                type
                lowerBound
                upperBound
              }
              iterations {
                type
                lowerBound
                upperBound
              }
              duration
            }
          }
          promotionWindow {
            endTime
            startTime
          }
          status
          cycleInterval
          pricingType
          eligibilityRules {
            products
            cycleInterval
            pricingType
            partnerType
            partnerTier
            saleTransitionType
            currency
          }
          applicationReason {
            id
            readableName
            customisable {
              id {
                type
                anyOf {
                  readableName
                  id
                }
              }
            }
          }
          customisableReasons {
            readableName
            id
          }
          isPromotionCustomisable
          type
        }
        notApplicablePromotionCodesWithReason
      }
    }
  }
`;
